import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Tabs as TabsDS } from '@certilogo/design-system';
import map from 'lodash/map';
import ContentsGroup from 'components/cms/ContentsGroup';
import * as isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import { TabList } from './styles';

const Tabs = ({
  tab,
  logEventName = 'open tab',
  colorType,
  propsBag,
  propsBag: { logger } = {},
  style,
  componentType,
  completeAction,
  gtm,
}) => {
  const [rendered, setRendered] = useState(false);
  const [showTabs, setShowTabs] = useState(tab.map((obj) => !!obj));
  const handleOnSelect = (index) => {
    if (logger) {
      logger({
        action: 'click',
        type: componentType,
        label: tab[index].title,
        gtm,
        start: 1,
        end: 1,
        event: { type: 'tabs', name: logEventName, category: 'tabs' },
      });
    }
  };

  return (
    <TabsDS.Tabs
      colorType={colorType}
      {...style}
      onSelect={handleOnSelect}
      domRef={(nd) => {
        if (!rendered && nd) {
          _.forEach(nd.getElementsByClassName('tab-panel'), (el, index) => {
            if (el.querySelectorAll('div').length === 1) {
              const newTabs = showTabs;
              newTabs[index] = false;
              setShowTabs(newTabs);
            }
          });
        }
        setRendered(true);
      }}
    >
      <TabList colorType={colorType}>
        {map(
          tab,
          ({ title }, index) =>
            !isEmpty(title) &&
            showTabs[index] && (
              <TabsDS.Tab>
                <FormattedMessage
                  id={title}
                  defaultMessage={title}
                  values={propsBag}
                  colorType={colorType}
                />
              </TabsDS.Tab>
            ),
        )}
      </TabList>

      {map(
        tab,
        ({ bodyContents }, index) =>
          showTabs[index] && (
            <TabsDS.TabPanel colorType={colorType} className="tab-panel" forceRender>
              {map(bodyContents, ({ contents_group: data }) => (
                <ContentsGroup
                  data={data}
                  propsBag={propsBag}
                  colorType={colorType}
                  completeAction={completeAction}
                />
              ))}
            </TabsDS.TabPanel>
          ),
      )}
    </TabsDS.Tabs>
  );
};

Tabs.propTypes = {
  colorType: PropTypes.string,
  componentType: PropTypes.string,
  tab: PropTypes.array,
  logEventName: PropTypes.string,
  propsBag: PropTypes.object,
  style: PropTypes.object,
  completeAction: PropTypes.func,
  gtm: PropTypes.object,
};

export default Tabs;
